export const LABELS = {
    OCCUPATION: 'Occupation',
    DOCTORS: `Doctor's name`,
    REASON: 'Reason for visit',
    NOTE: 'Note',
}

export const STEP = {
    ONE: 'Select a doctor and define the reason of your visit',
    TWO: `Chose a day for an appointment`,
    THREE: 'Select an available timeslot',
}

export const STATUS = {
    CONFIRMED: 'Appointment is confirmed',
    CANCELED: 'Appointment is cancelled',
    WAITING: 'Waiting for confirmation',
}

export const EDIT_CARD_OPTION ={
    CREATE: 'Create a resolution',
    EDIT: 'Edit an appointment',
    CONFIRM: 'Confirm an appointment',
    CANCEL: 'Cancel an appointment',
    DELETE: 'Delete',
}

export const FREE_TIMES = {
    START: 8,
    END:21,
}